// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class HtmlContent extends TrackingModel {
	public HtmlContentId: number = 0;
	public Name: string = "";
	public Description?: string;
	public Moniker?: string;
	public Body: string = "";
	public AvatarBlobPath?: string;
	public PublicationPersonId?: number;
	public PublishedOnUTC?: Date;
}